// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE (Supabase migration V2 - PREVIEW ONLY)
// version  : 2.0
// updated  : 2026-06-20
// protected: NO
// changelog: v2.0 (Parity P0-4) - lifecycle DRAFT->Dispatch->Terima->Batal.
//            Create/dispatch/cancel=Store asal; receive=Gudang.
// =============================================================================
// Retur Store -> Gudang. Store menyiapkan & dispatch retur, Gudang menerima. Stok real-time.
import React from "react";
import { Undo2 } from "lucide-react";
import { useV2Auth } from "@/v2/V2AuthContext";
import { DocumentFlow } from "@/v2/components/DocumentFlow";
import { DefectWaitingList } from "@/v2/components/DefectWaitingList";
import { WAREHOUSES, STORES, defaultGudang, defaultStore, allowedStores } from "@/v2/components/helpers";
import { GUDANG, STORE, KACAB } from "@/v2/menu";

export default function ReturPage() {
  const { me } = useV2Auth();
  const role = me?.role;
  const gudang = GUDANG.includes(role);
  const store = STORE.includes(role);
  const kacab = KACAB.includes(role);

  return (
    <DocumentFlow
      testid="v2-retur-page"
      title="Retur"
      icon={Undo2}
      listPath="/api/v2/returns"
      createPath="/api/v2/returns"
      dispatchPath={(id) => `/api/v2/returns/${id}/dispatch`}
      receivePath={(id) => `/api/v2/returns/${id}/receive`}
      cancelPath={(id) => `/api/v2/returns/${id}/cancel`}
      sourceLabel="Store Asal"
      targetLabel="Gudang Tujuan"
      sourceOptions={allowedStores(me)}
      targetOptions={(src) => (src === "STORE_BORNEO" ? ["GUDANG_SMD"] : src === "STORE_AREMA" ? ["GUDANG_SBY"] : WAREHOUSES)}
      defaultSource={defaultStore(me?.region)}
      defaultTarget={defaultStore(me?.region) === "STORE_BORNEO" ? "GUDANG_SMD" : "GUDANG_SBY"}
      hasReason
      buildBody={({ source, target, reason, qrs }) => ({ from_store: source, to_location: target, qr_ids: qrs, reason })}
      docType="return"
      canCreate={store}
      canDispatch={store}
      canReceive={gudang}
      canCancel={store || kacab}
      receiverLocation={defaultGudang(me?.region)}
      createLabel="Buat Retur (Disiapkan)"
      enablePhotos
      photosPath={(id) => `/api/v2/returns/${id}/photos`}
      linesPath={(id) => `/api/v2/returns/${id}/lines`}
      extraCreateSection={({ source, qrs, setQrs, createdTick }) => (
        <DefectWaitingList
          store={source}
          selected={qrs}
          onToggle={(qr) => setQrs(qrs.includes(qr) ? qrs.filter((q) => q !== qr) : [...qrs, qr])}
          refreshKey={createdTick}
          testid="v2-retur-defects"
        />
      )}
      emptyTitle="Belum ada retur"
      emptyDescription="Retur muncul di sini setelah Staff Store membuat retur dan mengirimkannya ke gudang. Buat retur baru pada panel di samping."
    />
  );
}
